export function getTenant() {
	const searchParams = new URLSearchParams(window.location.search);
	const hostname = searchParams.get('tenant');

	return hostname;
}
